module.exports = __webpack_public_path__ + "img/about_icon_1.07409d91.png";